import { render, staticRenderFns } from "./FormatColorTextIcon.vue?vue&type=template&id=cb731aa0"
import script from "./FormatColorTextIcon.vue?vue&type=script&lang=js"
export * from "./FormatColorTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports